export interface ProxyApp {
  controlTower: string;
  controlTowerAlt?: string;
  imageApi: string;
}

export const proxyApp: ProxyApp = {
  controlTower: 'http://201.20.115.209:3681/api',
  imageApi: 'https://l9lq9on9c1.execute-api.sa-east-1.amazonaws.com/image',
};
